import React, { useState } from 'react';

import styled from 'styled-components';

import CloseIcon from 'common/Icons/CloseIcon';
import Button from 'components/lib/Button';
import LoaderRibbed from 'components/lib/LoaderRibbed';
import { CommunityAdminListType } from 'types/communities';

import CommunityAdminContentCompetitorsListEmpty from './CommunityAdminContentCompetitorsListEmpty';
import { useCommunityAdminContext } from './CommunityAdminContextProvider';
import ConfirmModal from '../../../common/Modal/ConfirmModal';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1;
  gap: 10px;
  height: 100%;
  overflow-y: auto;
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--line-gray);
  padding: 14px 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
`;

const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`;

const Community = styled.span`
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const Company = styled.span`
  font-size: 12px;
  color: var(--text-primary);
`;

const Address = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
`;

const CommunityAdminContentCompetitorsList = () => {
  const { loadingCompetitors, competitors, setCompetitors } = useCommunityAdminContext();
  const [removeCompetitorCommunity, setRemoveCompetitorCommunity] = useState<CommunityAdminListType | null>(null);

  const handleRemoveCompetitor = (community: CommunityAdminListType | null) => {
    setCompetitors((prev: CommunityAdminListType[]) =>
      prev.filter((item: CommunityAdminListType) => item.id !== community?.id)
    );
    setRemoveCompetitorCommunity(null);
  };

  return (
    <Container className={'mini-scroll'}>
      {loadingCompetitors && <LoaderRibbed active={loadingCompetitors} />}
      {(competitors ?? []).map((community: CommunityAdminListType) => (
        <Item key={community.id}>
          <ItemInfo>
            <Community>{community.comunity_name}</Community>
            <Company>{community.company.name}</Company>
            <Address>{community.address}</Address>
          </ItemInfo>
          <Button
            shape="circle"
            type={'link'}
            size={'small'}
            icon={<CloseIcon size={14} />}
            onClick={() => {
              setRemoveCompetitorCommunity(community);
            }}
          />
        </Item>
      ))}
      <ConfirmModal
        open={Boolean(removeCompetitorCommunity)}
        title={'Remove Competitor'}
        subtitle={removeCompetitorCommunity?.comunity_name || ''}
        description={
          <div style={{ padding: '12px 0px' }}>This action will remove selected community form the competitor list</div>
        }
        confirmLabel={'Confirm'}
        onConfirm={() => handleRemoveCompetitor(removeCompetitorCommunity)}
        onCancel={() => setRemoveCompetitorCommunity(null)}
      />
      {!loadingCompetitors && (competitors || []).length === 0 && <CommunityAdminContentCompetitorsListEmpty />}
    </Container>
  );
};

export default CommunityAdminContentCompetitorsList;
